export default __webpack_public_path__ + "static/media/prestashop.4bd92d4f.png";